import { SquareArrowOutUpRightIcon } from "lucide-react";
import { IMG_PATH } from "../../server";
import "./loopview.css";

const LoopThreebody = ({ data }) => {
  const materialLink =
    data?.viewMaterialsLink || data?.groupedQuestions?.[0]?.viewMaterialsLink;

  return (
    <div className="m-1">
      <h5 className="title">
        {data.TitleName.split("\n").map((line, index) => (
          <div key={index} className="title-line">
            {line}
          </div>
        ))}
      </h5>

      <p className="bodytext1">{data.bodytext1}</p>

      <div className="w-full aspect-video mt-2 rounded-md shodowview overflow-hidden">
        <img
          src={IMG_PATH + data.image1}
          alt="LoopThreeImg"
          className="w-full h-full object-cover "
        />
      </div>

      {materialLink && (
        <div className="card-footer">
          <button
            onClick={() => window.open(materialLink, "_blank")}
            style={{ marginTop: "16px" }}
            className="btn w-100  border border-black text-black bg-white flex items-center justify-center gap-2 mt-5"
          >
            View Materials
            <SquareArrowOutUpRightIcon className="text-black w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  );
};

export default LoopThreebody;
